
import { put} from 'redux-saga/effects';
import { addTemporarySession } from '../../../state/message/messageSessionSlice';

export function* addTemporaryMessageSessionSaga(action) {
  try {
    const temporaryMessageSession = action.payload;
    yield put(addTemporarySession(temporaryMessageSession));
  } catch (error) {
    console.error('Error in adding temporary message session :', error);

  }
}
